export default "__VITE_ASSET__BzRqZBoS__"